import React from 'react';
import { DeliveryFilters } from '../../../../app/models/Delivery';

interface Props {
    filter: DeliveryFilters;
    setFilter: (filter: DeliveryFilters) => void;
    onSearch: () => void;
}

const DeliveryFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter({ ...filter, [name]: value });
    };

    const handleSearch = () => {
        // Siempre volver a la primera página al buscar
        setFilter({ ...filter, page: 1 });
        onSearch();
    };

    const handleClear = () => {
        setFilter({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            id: '',
            sales_order_id: undefined,
            status: '',
            is_inventory_processed: '',
            delivery_date_from: '',
            delivery_date_to: ''
        });
        onSearch();
    };

    return (
        <div className="row">
            {/* Primera fila: Id, Pedido, Estado, Inventario, Botones */}
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="id">
                            Id Entrega
                        </label>
                        <input
                            type="number"
                            id="id"
                            name="id"
                            className="form-control form-control-sm"
                            value={filter.id ?? ''}
                            onChange={handleInputChange}
                            title="Id Entrega"
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="sales_order_id">
                            Pedido
                        </label>
                        <input
                            type="number"
                            id="sales_order_id"
                            name="sales_order_id"
                            className="form-control form-control-sm"
                            value={filter.sales_order_id ?? ''}
                            onChange={handleInputChange}
                            title="Id Pedido de Venta"
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="status">
                            Estado
                        </label>
                        <select
                            id="estado"
                            name="status"
                            className="form-select form-select-sm"
                            value={filter.status ?? ''}
                            onChange={handleInputChange}
                        >
                            <option value="">Todos</option>
                            <option value="PENDING">Pendiente</option>
                            <option value="IN_TRANSIT">En tránsito</option>
                            <option value="DELIVERED">Entregada</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="is_inventory_processed">
                            Inventario
                        </label>
                        <select
                            id="is_inventory_processed"
                            name="is_inventory_processed"
                            className="form-select form-select-sm"
                            value={filter.is_inventory_processed ?? ''}
                            onChange={handleInputChange}
                        >
                            <option value="">Todos</option>
                            <option value="true">Procesado</option>
                            <option value="false">Pendiente</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-auto d-flex align-items-end">
                    <div className="mb-3">
                        <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={handleSearch}
                        >
                            <i className="mdi mdi-magnify" /> Buscar
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={handleClear}
                        >
                            <i className="mdi mdi-refresh" /> Limpiar
                        </button>
                    </div>
                </div>
            </div>

            {/* Segunda fila: Fechas de entrega */}
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="delivery_date_from">
                            Fecha entrega desde
                        </label>
                        <input
                            type="date"
                            id="delivery_date_from"
                            name="delivery_date_from"
                            className="form-control form-control-sm"
                            value={filter.delivery_date_from ?? ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="delivery_date_to">
                            Fecha entrega hasta
                        </label>
                        <input
                            type="date"
                            id="delivery_date_to"
                            name="delivery_date_to"
                            className="form-control form-control-sm"
                            value={filter.delivery_date_to ?? ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeliveryFilter;

